import {useQuery} from "react-query";
import ngage from "../../services/ngage";
import {PlaceFilters} from "../../services/ngage/places";

export default function useGetPlaces(
  criteria: PlaceFilters = {},
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  return useQuery(
    ['places.all', criteria],
    () => ngage.places.filtered(criteria),
    {enabled, keepPreviousData}
  );
}